import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  border-radius: 5px;
  background-color: white;
  width: ${props => props.fit ? 'fit-content' : '100%'};
  padding: 20px;
`;
